<template>
	<el-container id="notify">
		<div v-loading="loading">
			<div class="guide" v-if="guideList.length!=0">
				<div class="titBox" style="margin-top:0;">
					<p class="tit">
						消息通知
						<span v-if="sum" style="color: red;font-weight: 400;font-size: 12px;margin-left: 10px;">{{sum}}条新消息</span>
					</p>
					<el-button v-if="sum" size="mini" type="primary" class="full_reading" plain @click="full_reading()">全部标记为已读</el-button>
					<el-button v-else size="mini" type="info" class="full_reading" plain disabled>全部标记为已读</el-button>
				</div>
        	    <div class="guide_text">
        	        <p @click="guide_text(item)" class="guide_text_p" v-for="(item,i) in guideList" :key="i">
                        <i class="iconfont" v-if="item.have_read==0">&#xe693;</i>
						<i class="iconfont" style="color: #a3a3a3;" v-else>&#xe661;</i>
						【{{notifyType[item.type].name}}】
                        {{item.title}}
                        <span class="iconfont_right">{{item.type==1?'系统':'反馈'}}时间：{{item.created_at}}</span>
                    </p>
        	    </div>
				<div class="paging">
					<el-pagination
    				  @size-change="handleSizeChange"
    				  @current-change="handleCurrentChange"
    				  :current-page="params.page"
    				  :page-sizes="[10, 20, 30, 40]"
    				  :page-size="params.page_size"
    				  layout="total, sizes, prev, pager, next, jumper"
    				  :total="total">
    				</el-pagination>
				</div>

        	</div>
			<div class="nodata" v-else>
				<img :src="nodataImg">
				<p>暂无内容</p>
			</div>
		</div>
        
	</el-container>
</template>

<script>
export default {
	name: 'guide'
	,data () {
		return {
            guideList:[],
			loading:false,
			// currentPage4:1,
			params:{
				page:1,
				page_size :10
			},
			total:0,
			sum:0,
			notifyType:{}
		}
	}
	,mounted:function(){
		this.getguide()
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
		// pageSize 改变时会触发
		handleSizeChange(data){
			this.params.page_size  = data
			this.getguide()
		},
		// currentPage 改变时会触发
		handleCurrentChange(data){
			this.params.page = data
			this.getguide()
		},
		// 跳转
		guide_text(data){
			// console.log(data);
			// return false
			data.have_read = 1
			this.$router.push({
				name:'notify_info',
				query:{
					id:data.id
				}
			});
		},
		//列表
		getguide(){
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			this.$ajax.get(serverSrc + qianzui + "/notify/notifyTotal")
			.then(res=>{
				this.sum = res.data.data
			})
			this.$ajax.get(serverSrc + qianzui + "/notify/notifyType")
			.then(res=>{
				for (let i = 0; i < res.data.data.length; i++) {
					this.notifyType[res.data.data[i].id] = res.data.data[i]
				}
				this.$ajax.get(serverSrc + qianzui + "/notify/notifyList",{params:this.params})
				.then(res=>{
					this.guideList = res.data.data.data
					this.total = res.data.data.total
					this.loading = false
					// console.log(res);
					// console.log(res.list.data);
				})
			})
		},
		//全读
		full_reading(){
			let that = this
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			this.$ajax.post(serverSrc + qianzui + "/notify/notifyMarkRead")
			.then(res=>{
				that.loading = false
				if (res.data.code==0) {
					that.guideList.map(v=>{
						v.have_read = 1
					}) 
					that.sum = 0
					that.$message({
          				message: '全部通知已标记为已读状态',
          				type: 'success'
					});
					$(".show_wechatProgram").removeClass('new_message')
				}
			})
		}
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
	.full_reading{
		margin-top: 8px;
    	float: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/notify/index.vue